
export default "/assets/photo-micro.15fb0257.svg"